import React, { useState } from "react";
import { ReactComponent as SwitchOnn } from "assets/img/icons/switchOnn.svg";
import { ReactComponent as SwitchOff } from "assets/img/icons/switchOff.svg";
import TeamService from "services/TeamService";
import { useToasts } from "react-toast-notifications";
import { useTeamContext } from "store/contexts/teamContext";

const styles = {
  root: {
    display: "flex",
    cursor: "pointer",
  },
};

export default () => {
  const { team, setTeam } = useTeamContext();
  const { addToast } = useToasts();
  const classes = styles;
  const [switchOn, setSwitchOn] = useState(team?.profile?.notification_alert);

  const updateNotificationAlert = async (value) => {
    try {
      await TeamService.postTeamProfile(team.id, null, null, value);

      setSwitchOn(value);
      if (value) {
        addToast("Team Notification is activated", {
          appearance: "success",
        });
      }

      if (!value) {
        addToast("Team Notification is disabled", {
          appearance: "error",
        });
      }
    } catch (error) {
      console.log(error);
    }

    setTeam({
      ...team,
      profile: {
        ...team.profile,
        notification_alert: value,
      },
    });
  };

  return (
    <>
      <div style={classes.root}>
        <div>
          {!switchOn && (
            <SwitchOnn
              className="mx-2 switchIconOff"
              onClick={() => updateNotificationAlert(!switchOn)}
            />
          )}
          {switchOn && (
            <SwitchOff
              className="mx-2 switchIcon"
              onClick={() => updateNotificationAlert(!switchOn)}
            />
          )}
        </div>
        <span>Show Notifications</span>
      </div>
    </>
  );
};
